// src/redux/services/ExchangeRateSlice.js
import { createApi, } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";  
import { mapExchangeRateResponse,mapExchangeRateRequest } from "@/redux/mappers/Export/CreateNewJob/exchRateMappers";

export const exchangeRateApi = createApi({
  reducerPath: "exchangeRateApi",
  baseQuery,
  tagTypes: ["ExchangeRate"],
  endpoints: (builder) => ({
    getExchangeRateById: builder.query({
      query: ({ id }) => `/export/exchangeRate/${id}`,
      transformResponse: (response) =>
        mapExchangeRateResponse(response?.data) ?? null,
      providesTags: (result, error, id) => [{ type: "ExchangeRate", id }],
    }),

    // ✅ Update Exchange Rate (PUT)
    updateExchangeRate: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/exchangeRate/${id}`,
        method: "PUT",
        headers: {
          "X-Request-Id": crypto.randomUUID(),
        },
        // 🔹 Map request to ensure numeric fields
        body: { exchangeRates: mapExchangeRateRequest(data).exchangeRates },
      }),
      invalidatesTags: ["ExchangeRate"],
    }),
  }),
});


// ✅ Hooks
export const {
  useGetExchangeRateByIdQuery,
  useLazyGetExchangeRateByIdQuery,
  useUpdateExchangeRateMutation,
} = exchangeRateApi;


